angular.module('GraphCommentModule')
  .directive('searchComment', [
    'CommentService', '$rootScope', '$anchorScroll','$timeout',
    function (CommentService, $rootScope, $anchorScroll, $timeout) {
      'use strict';
      return {
        restrict: 'E',
        replace: true,
        templateUrl: 'search.html',
        link: function (scope, el, attrs) {
          scope.CommentService = CommentService;
          scope.searchValue = "";
          scope.commentNumber = null;
          scope.limit = 10;
          scope.isDetails = false;
          var saveValue = null;
          scope.searchComments = function (event) {
            if (event.keyCode === 13 && saveValue !== scope.searchValue) {
              scope.commentNumber = null;
              scope.list = [];
              saveValue = scope.searchValue;
              CommentService.getSearch({
                search: scope.searchValue
              }).then((res) => {
                scope.commentNumber = res.data.count;
                scope.page = 1;
              });
            }
          }

          scope.setPage = function (index) {
            if (scope.currentPage === index) return;
            scope.currentPage = index;
           
            CommentService.getSearch({
              search: scope.searchValue,
              page: index
            });
            $timeout(function() {
              $anchorScroll("search-back");
            }, 300);
           
          }
    
          $rootScope.$on('comment:detail:close', function() {
            scope.isDetails = false;
            scope.commentDetails = null;
          });

          $rootScope.$on('comment:detail:open', function(event,cmt) {
            $anchorScroll("search");
            scope.isDetails = true;
            $rootScope.hideHeader = true;
            scope.commentDetails = cmt;
            $timeout(function() {
              scope.showDetails = true;
            }, 300)
           
          });
        },
      };
    }]);
